import React, { useContext } from "react";
import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import { Context } from "../../shared/Context/Context";
import { Fade } from "react-awesome-reveal";
import { FormattedMessage } from "react-intl";

const Home = () => {
  const { tabletOrLess, lang } = useContext(Context);

  return (
    <Flex justify="center" flexDir="column" align="center">
      <Heading
        p={tabletOrLess ? "100px 20px 0px 20px" : "40px 0px 0px 0px"}
        fontSize={tabletOrLess ? "20px" : "40px"}
        textAlign="center"
      >
        <FormattedMessage
          id="app.home.heading"
        />
      </Heading>
      <Flex flexWrap="wrap" justify="center" align="center">
        <Fade triggerOnce cascade>
          {lang.Informacion.map((info, index) => {
            return (
              <Box
                display="inline-block"
                w="240px"
                m="50px"
                textAlign="center"
                key={JSON.stringify(info)}
              >
                <Box
                  h="230px"
                  w="200px"
                  overflow="hidden"
                  borderRadius="0px 0px 20px 20px"
                  display="inline-block"
                >
                  <Flex>
                    <Box
                      display="inline-block"
                      borderRadius="20px"
                      overflow="hidden"
                      p={0}
                      transform="skew(0deg, 13deg)"
                      fontSize={0}
                      m="30px 0px 0px 0px"
                      backgroundColor="#c8c2c2"
                      h="250px"
                      w="200px"
                      backgroundPosition="center"
                      backgroundSize="cover"
                      backgroundImage={info.img}
                    ></Box>
                  </Flex>
                </Box>
                <Flex
                  justify="center"
                  align="center"
                  flexDir="column"
                  boxShadow="0px 0px 10px 0px rgba(0, 0, 0, 0.2)"
                  p="120px 20px 20px 20px"
                  borderRadius="20px"
                  backgroundColor="#ff6e6c"
                  mt="-120px"
                  lineHeight="19px"
                  fontSize="14px"
                  minH="350px"
                >
                  <Heading
                    color="#FFFFFF"
                    m="20px 0px 10px 0px"
                    fontSize="18px"
                  >
                    <FormattedMessage
                      id={lang.Informacion[index].title}
                    />
                  </Heading>
                  <Text fontWeight="bold">
                    <FormattedMessage
                      id={lang.Informacion[index].info}
                    />
                  </Text>
                </Flex>
              </Box>
            );
          })}
        </Fade>
      </Flex>
    </Flex>
  );
};

export default Home;
